/**
 * Learn more about deep linking with React Navigation
 * https://reactnavigation.org/docs/deep-linking
 * https://reactnavigation.org/docs/configuring-links
 */

import { LinkingOptions, getStateFromPath } from "@react-navigation/native";
import * as Linking from "expo-linking";
import { Platform } from "react-native";
import { RootStackParamList } from "./Navigation.types";

const linking: LinkingOptions<RootStackParamList> = {
  prefixes: [Linking.createURL("/")],
  enabled: Platform.OS !== "android",
  config: {
    screens: {
      "not-found": "*",
      login: "auth/login",
      "set-password": "auth/set-password",
      "forgot-password": "auth/forgot-password",
      "reset-password": "auth/reset-password",
      register: "auth/register",
      main: {
        path: "",
        screens: {
          home_remastered: "home",
          "my-games": "my-games",
          stats: "rankings",
          game: "game",
          profile: "profile",
          "my-groups": "my-groups",
          "eqipa-card": {
            path: "eqipa-card/:playerId?",
            parse: {
              playerId: (id: string | undefined) => (id ? Number(id) : undefined),
            },
          },
          group: "group",
          // groupRM: "groupRM",
          "new-game": "new-game",
          "edit-game": "edit-game",
          "competitions-list": "competitions",
          "competition-detail": {
            path: "competition/:competitionId/:competitionName/:initialTab?",
            parse: {
              competitionId: (id: string) => Number(id),
              competitionName: (name: string) => decodeURIComponent(name),
              initialTab: (tab: string | undefined) => (tab === "matches" || tab === "stats" ? tab : undefined),
            },
            stringify: {
              competitionId: (id: number) => String(id),
              competitionName: (name: string) => encodeURIComponent(name),
              initialTab: (tab: "stats" | "matches" | undefined) => tab || "",
            },
          },
        },
      },
      vote: "vote",
    },
  },
  getStateFromPath: (path, options) => {
    if (Platform.OS !== "web" || (!path.startsWith("/auth/set-password") && !path.startsWith("/auth/reset-password")))
      return getStateFromPath(path, options);

    const webPath = window.location.hash;

    // Extract parameters from the hash and return them as route.params
    const params =
      webPath
        .replace("#", "")
        .split("&")
        .reduce((acc: any, param: string) => {
          const [key, value] = param.split("=");
          acc[key] = value;
          return acc;
        }, {}) || {};

    return { routes: [{ name: path.replace("/auth/", ""), params }] };
  },
};

export default linking;
